
export class GetEventInfoAndTicketQuantityByStripePaymentIntentIdsRequestDto {
  stripePaymentIntentIds: string[];
}
